export type ZoneGroupKey = "1AZ" | "3AZ" | "LZ" | "Other";

export type ContinentType = {
  continentCode: string;
  continentTitle: string;
  datacenterLocations: undefined | Array<string>;
};
export type DatacenterType = {
  location: string;
  title: string;
  dataImage?: string;
};

export const continents: Array<ContinentType> = [
  {
    continentCode: "ALL",
    continentTitle: "All locations",
    datacenterLocations: undefined,
  },
  {
    continentCode: "AF",
    continentTitle: "Africa",
    datacenterLocations: ["RBA"],
  },
  {
    continentCode: "NA",
    continentTitle: "North America",
    datacenterLocations: ["BHS"],
  },
  {
    continentCode: "EU",
    continentTitle: "Central Europe",
    datacenterLocations: ["DE", "SBG", "WAW", "PRG"],
  },
  {
    continentCode: "EU",
    continentTitle: "Western Europe",
    datacenterLocations: [
      "AMS",
      "LUX",
      "MRS",
      "ZRH",
      "PAR",
      "GRA",
      "RBX",
      "UK",
      "BRU",
      "DLN",
      "VIE",
    ],
  },
  {
    continentCode: "ASIA",
    continentTitle: "Asia Pacific",
    datacenterLocations: ["SGP", "YNM"],
  },
  {
    continentCode: "ASIA",
    continentTitle: "Oceania",
    datacenterLocations: ["SYD"],
  },
  {
    continentCode: "EU",
    continentTitle: "Northern Europe",
    datacenterLocations: ["CPH", "HEL", "OSL", "STO"],
  },
  {
    continentCode: "EU",
    continentTitle: "Southern Europe",
    datacenterLocations: ["MAD", "MIL"],
  },
];

export const datacenterDetails: Array<DatacenterType> = [
  {
    location: "BHS",
    title: "Beauharnois",
  },
  {
    location: "DE",
    title: "Frankfurt",
  },
  {
    location: "GRA",
    title: "Gravelines",
  },
  {
    location: "RBX",
    title: "Roubaix",
  },
  {
    location: "SBG",
    title: "Strasbourg",
  },
  {
    location: "UK",
    title: "London",
  },
  {
    location: "WAW",
    title: "Warsaw",
  },
  {
    location: "RBA",
    title: "Rabat",
  },
  {
    location: "AMS",
    title: "Amsterdam",
  },
  { location: "LUX", title: "Luxembourg" },
  { location: "MRS", title: "Marseille" },
  { location: "ZRH", title: "Zurich" },
  { location: "PAR", title: "Paris" },
  { location: "SGP", title: "Singapore" },
  { location: "YNM", title: "Mumbai" },
  { location: "SYD", title: "Sydney" },
  { location: "PRG", title: "Prague" },
  { location: "CPH", title: "Copenhagen" },
  { location: "HEL", title: "Helsinki" },
  { location: "OSL", title: "Oslo" },
  { location: "STO", title: "Stockholm" },
  { location: "MAD", title: "Madrid" },
  { location: "MIL", title: "Milan" },
  { location: "BRU", title: "Brussels" },
  { location: "DLN", title: "Dublin" },
  { location: "VIE", title: "Vienna" },
];

export const getCountryFlag = (
  countryCode: string,
  type: "iso2" | "iso3" = "iso3"
) => {
  if (countryCode === "") return "";
  const baseCdnUrl = import.meta.env.VITE_FLAG_URL;
  if (type === "iso3") {
    return `${baseCdnUrl}/${countryCode}.svg`;
  }
  if (type === "iso2") {
    return `${baseCdnUrl}/iso2/${countryCode}.svg`;
  }
  return "";
};

export const regionsZoneTypes: Array<{
  value: ZoneGroupKey;
  title: string;
  tag: string;
  description: string;
}> = [
  {
    value: "1AZ",
    title: "1-AZ Region",
    tag: "1-AZ",
    description: "Resilient and low cost deployment in 1 availability zone.",
  },
  {
    value: "3AZ",
    title: "3-AZ Region",
    tag: "3-AZ",
    description:
      "High resilience/high availability deployment for your critical applications across 3 availability zones.",
  },
  {
    value: "LZ",
    title: "Local Zone",
    tag: "Local Zone",
    description:
      "Deploy your applications as geographically close to your users as possible, for low latency and compliant data residency.",
  },
];

export const getServicesZoneGroup = (
  planCode: string,
  startsWith: string
): ZoneGroupKey => {
  if (planCode === startsWith) return "1AZ";
  if (planCode.endsWith(".3AZ")) return "3AZ";
  if (planCode.includes(".LZ.")) return "LZ";
  return "Other";
};
